
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },
  head() {
    return {
      title: "Les critères clés pour choisir un hébergement web performant",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Le choix de l’hébergement web impacte directement la vitesse et la fiabilité de votre site. Découvrez les critères essentiels pour choisir un hébergement web.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Les critères clés pour choisir un hébergement web performant",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Le choix de l’hébergement web impacte directement la vitesse et la fiabilité de votre site. Découvrez les critères essentiels pour choisir un hébergement web.",
        },
      ],
    };
  },
};
